import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ArticlesService } from '../../../services/articles.service';
import { Multitenant } from '../../../services/multitenant.provider';
import { AuthProvider } from '../../../services/auth.provider';
import { MetaProvider } from '../../../services/meta.provider';
import { PopUpService } from '../../../shared/components/pop-up/pop-up.service';
import { PopUp } from '../../../models/popup.model';

@Component({
  selector: 'app-thematicfilescat',
  templateUrl: 'thematicfilescat.html',
  styleUrls: ['thematicfilescat.scss']
})
export class ThematicfilescatPage implements OnInit {
  public categories: any;
  public newspaper: string;
  public themeClass: any;
  public isActivePage: string;
  public popup: PopUp = new PopUp();
  public tempPopUp: boolean;
  public showSpinner: boolean;

  constructor(
    private router: Router,
    private actRoute: ActivatedRoute,
    private articlesService: ArticlesService,
    private multiTenant: Multitenant,
    private auth: AuthProvider,
    private meta: MetaProvider,
    private popUpService: PopUpService
  ) { }
  ngOnInit(): void {
    this.actRoute.paramMap.subscribe( paramMap => {
      this.newspaper = paramMap.get('newspaper');
      if (this.auth.isAuthenticated() && this.auth.oneMainNewspaper()) {
        this.newspaper = this.auth.hasAccessToMain();
      }

      this.getCategories(this.newspaper);
      this.meta.clearHead();
      this.meta.setMetaData('dossiersCateg', this.newspaper);
    });
  }

  ionViewDidLoad() {
    this.themeClass = this.multiTenant.getDomainClass();
    this.isActivePage = 'dossiers';
    if (this.newspaper === 'election-presidentielle-2022' && (this.themeClass === 'mquo' || this.themeClass === 'actu') ) {
      this.makeRedirect(this.themeClass);
    }
  }

  ionViewDidEnter() {
    /* UnIdentified pop-up show */
    if (!this.auth.isAuthenticated() && this.popUpService.havePassedSevenDays() && this.multiTenant.getDomainClass() === 'playbacpresse') {
      this.tempPopUp = true;
      this.popup.type = 'unIdentifiedUser';
    }
    /* UnIdentified pop-up show */
  }

  getCategories(newspaper) {
    this.showSpinner = true;
    this.articlesService.getThematicFilesCategories(newspaper).subscribe((response) => {
      this.showSpinner = false;
      this.categories = response;
    });
  }

  goToSousThemes(theme) {
    this.router.navigate(['dossiers-actualite', this.newspaper, theme.slug]);
  }

  makeRedirect(newspaperSubname: string) {
    let themeslug: string;
    let slug: string;
    switch (newspaperSubname) {
      case 'mquo':
        themeslug = 'general-3';
        slug = 'election-presidentielle-2022';
        break;
      case 'actu':
        themeslug = 'general-1';
        slug = 'election-presidentielle-2022-1';
        break;
    }

    this.router.navigate(['dossiers-actualite', newspaperSubname, themeslug, slug]);
  }
}
